import CityPageTemplate from "../city-template/CityPageTemplate";
import { southCharlestonConfig } from "./data";

export default function SouthCharlestonPage() {
  return <CityPageTemplate config={southCharlestonConfig} />;
}